export function findFirst(arr) {
  return arr.find(Boolean);
}